import { ChangeDetectorRef, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'core/services/auth.service';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { LogOutConfirmationModalComponent } from '../../shared/modal/log-out-confirmation-modal/log-out-confirmation-modal.component';
import { User } from 'shared/types/user.model';
import { NgClass } from '@angular/common';
import { UserAvatarComponent } from 'shared/components/user-avatar/user-avatar.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  standalone: true,
  imports: [NgClass, UserAvatarComponent, TranslateModule, NzModalModule, LogOutConfirmationModalComponent]
})
export class UserProfileComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  readonly logOutDialogVisible = signal(false);

  public get user(): User {
    return this.authService.currentUser;
  }
  constructor(
    public authService: AuthService,
    private _router: Router
  ) {}

  public openLogOutConfirmationModal(): void {
    this.logOutDialogVisible.set(true);
    this.changeDetectorRef.detectChanges();
  }

  public closeLogOutConfirmationModal(): void {
    this.logOutDialogVisible.set(false);
    this.changeDetectorRef.detectChanges();
  }

  public confirmLogOut(): void {
    this.closeLogOutConfirmationModal();
    this.authService.logOut();
  }

  public goTo(url: string): void {
    this._router.navigate([url]);
  }
}
